import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { PROFILE, IMAGES } from "../lib/data";

const STATS = [
  { k: "10+", v: "Years' Experience" },
  { k: "5.0", v: "Google Rating" },
  { k: "71", v: "Verified Reviews" },
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" className="border-t border-[#262626] bg-[#0A0A0A]" data-testid="about-section" ref={ref}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden">
            <motion.img
              style={{ y }}
              src={IMAGES.portrait}
              alt="Advocate Manpreet Singh Bhatti"
              className="w-full h-[116%] object-cover object-top"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[#262626]" />
            <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#0A0A0A] to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="font-serif text-2xl text-[#F7F5F2]">{PROFILE.name}</p>
              <p className="overline mt-1">{PROFILE.title}</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <span className="overline">About the Advocate</span>
            <h2 className="font-serif font-light text-4xl sm:text-5xl leading-[1.05] mt-5 text-[#F7F5F2] text-balance">
              A trusted name at the Punjab &amp; Haryana High Court.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-[#8C8C8C] leading-relaxed max-w-2xl">
              <p>
                <span className="text-[#F7F5F2]">MS Bhatti &amp; Associates</span> is a dedicated criminal law firm — practising anticipatory &amp; regular bail, quashing of FIRs, criminal appeals and revisions, NDPS defence and the criminal side of family disputes.
              </p>
              <p>
                Led by <span className="text-[#F7F5F2]">Advocate Manpreet Singh Bhatti</span>, the firm is deeply committed to defending liberty and pursuing justice for every client. Known for his dedication and clear-eyed approach, Mr. Bhatti brings urgency, discretion and command of procedure to each matter before the Court.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-12 grid grid-cols-3 border-t border-[#262626]">
              {STATS.map((s) => (
                <div key={s.v} className="py-6 pr-4 border-r border-[#262626] last:border-r-0" data-testid={`stat-${s.v}`}>
                  <p className="font-serif text-4xl lg:text-5xl text-[#C8A24B]">{s.k}</p>
                  <p className="text-xs text-[#8C8C8C] mt-2 uppercase tracking-wider">{s.v}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
